let passwordResetToken: string | null = null;

export function clearSensitiveAuthQuery(): void {
	if (typeof window === 'undefined') return;
	window.history.replaceState({}, '', `${window.location.pathname}${window.location.hash}`);
}

export function capturePasswordResetToken(): string | null {
	if (typeof window === 'undefined') return null;
	passwordResetToken = new URLSearchParams(window.location.search).get('token');
	if (passwordResetToken) clearSensitiveAuthQuery();
	return passwordResetToken;
}

export function readPasswordResetToken(): string | null {
	return passwordResetToken;
}

export function clearPasswordResetToken(): void {
	passwordResetToken = null;
}
